export default {"src":"/_next/static/media/hospital.bee2e482.svg","height":199,"width":198,"blurWidth":0,"blurHeight":0};